<div mat-dialog-title class="dialog-header d-flex justify-content-between">
  <div i18n="@@sendSponsoringEmail">Send Sponsoring Email</div>
  <mat-icon (click)="closeDialog()" class="cursor" i18n-label="@@closeDialogIcon">close</mat-icon>
</div>

@if (invalidCodes) {
  <div class="error invalid-cridentials d-flex justify-content-center align-items-center">
    <mat-icon class="mr-8" i18n-label="@@errorIcon">error</mat-icon>
    <span i18n="@@invalidCodesMessage">Please enter codes to proceed!</span>
  </div>
}

<mat-dialog-content>
  <form [formGroup]="sendEmailForm">
    <div class="form-group">
      <mat-form-field appearance="outline" class="w-100">
        <mat-chip-grid [disabled]="true" #chipList aria-label="Code selection" i18n-aria-label="@@codeSelectionLabel">
          @for (code of codes; track code) {
            <mat-chip-row
              [selectable]="selectable"
              [removable]="removable"
              (removed)="remove(code)">
              {{code}}
              @if (removable) {
                <mat-icon matChipRemove i18n-label="@@removeChipIcon">cancel</mat-icon>
              }
            </mat-chip-row>
          }
          <input
            data-testid="send_email_codes"
            placeholder="Code"
            i18n-placeholder="@@codePlaceholder"
            #codeInput
            [formControl]="codeCtrl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="add($event)">
        </mat-chip-grid>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
          @for (code of filteredCodes | async; track code) {
            <mat-option [value]="code">
              {{code}}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@firstNameLabel">First name</mat-label>
        <input data-testid="send_email_first_name" matInput id="firstName" i18n-placeholder="@@firstNamePlaceholder" placeholder="First name" name="firstName" formControlName="firstName" required />
        <mat-error>
          @if (!sendEmailForm.get('firstName').valid && sendEmailForm.get('firstName').touched) {
            @if (sendEmailForm.get('firstName').errors && sendEmailForm.get('firstName').errors['required'] || sendEmailForm.get('firstName').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@lastNameLabel">Last name</mat-label>
        <input data-testid="send_email_last_name" matInput id="lastName" i18n-placeholder="@@lastNamePlaceholder" placeholder="Last name" name="lastName" formControlName="lastName" required />
        <mat-error>
          @if (!sendEmailForm.get('lastName').valid && sendEmailForm.get('lastName').touched) {
            @if (sendEmailForm.get('lastName').errors && sendEmailForm.get('lastName').errors['required'] || sendEmailForm.get('lastName').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@emailLabel">Email</mat-label>
        <input data-testid="send_email_email" matInput id="email" placeholder="Email" i18n-placeholder="@@emailPlaceholder" name="email" formControlName="email" required />
        <mat-error>
          @if (!sendEmailForm.get('email').valid && sendEmailForm.get('email').touched) {
            @if (sendEmailForm.get('email').errors && sendEmailForm.get('email').errors['required']) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
          @if (sendEmailForm.get('email').errors && !sendEmailForm.get('email').errors['required'] && sendEmailForm.get('email').errors['emailNotValid']) {
            <span i18n="@@inValidEmail">Please enter a valid email</span>
          }
        </mat-error>
      </mat-form-field>
    </div>
    <div mat-dialog-actions>
      <button i18n="@@sendNotifyEmail" data-testid="send_email_button" class="w-100" mat-raised-button color="primary" (click)="onSubmit()">Send Notification Email</button>
    </div>
  </form>
</mat-dialog-content>